import { render, staticRenderFns } from "./AI-compare-class.vue?vue&type=template&id=7ddb4d03"
import script from "./AI-compare-class.vue?vue&type=script&lang=js"
export * from "./AI-compare-class.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports